import * as _ from 'lodash';
import * as React from 'react';
import history from 'login-utils/history';
import { Helmet } from 'react-helmet';
import * as queryString from 'query-string';

import * as deploymentConfig from 'login-utils/deploymentConfig';
import { getLoanOfficer } from 'login-apis/loanOfficerAPI';
import LeftPane from 'login-components/Common/PaneLayout/LeftPane/LeftPane';
import * as sessionUtils from 'login-utils/sessionUtils';
import PaneLayout from 'login-components/Common/PaneLayout/PaneLayout';
import LoanOfficerLeftPaneBody from './LoanOfficerLeftPaneBody';
import LoanOfficerRightPane from './LoanOfficerRightPane';

interface OwnState {
  avatar?: string;
  email?: string;
  phoneExtension?: string;
  phoneNumber?: number;
  fullName: string;
  nmlsId: string;
}

interface RouteProps {
  loIdentifier: string;
}

class LoanOfficerPage extends React.Component<ReactRouter.RouteComponentProps<RouteProps, {}>, OwnState> {
  state = {
    avatar: '',
    email: undefined,
    phoneExtension: '',
    phoneNumber: undefined,
    nmlsId: '',
    fullName: '',
  };

  async componentDidMount() {
    const { location, params } = this.props;
    sessionUtils.saveQueryToSession(queryString.parse(location.search));

    try {
      // this is needed because of ReactRouter props, params are always needed to enter the page
      if (params) {
        const loIdentifier = decodeURIComponent(params.loIdentifier);
        const loanOfficer = await getLoanOfficer(loIdentifier);
        this.setState({ ...loanOfficer });
      } else {
        throw new Error(`Must provide route params`);
      }
    } catch (e) {
      history.replace('/');
    }
  }

  metaTagDescription() {
    const { nmlsId } = this.state;
    const loanOfficerDescription = _.get(deploymentConfig.get(), 'loanOfficerPages.loanOfficerDescription');
    return _.compact([`NMLS #${nmlsId}`, loanOfficerDescription]).join('. ');
  }

  render() {
    const { email, fullName } = this.state;
    return (
      <React.Fragment>
        <Helmet>
          <meta name="description" content={this.metaTagDescription()} />
        </Helmet>
        <PaneLayout
          left={
            <LeftPane
              renderBody={() => <LoanOfficerLeftPaneBody {...this.state} />}
              // title should be first so that lo name can be read in search engine results
              appDocumentTitleProps={{ title: fullName, titleFirst: true }}
            />
          }
          right={<LoanOfficerRightPane email={email} />}
        />
      </React.Fragment>
    );
  }
}

export default LoanOfficerPage;
